export const billingLogoUrl = `${process.env.PUBLIC_URL || ''}/facturacion.png`;
